import { createTheme } from "@mui/material/styles";
import { themeOptions } from "@/themeOptions";

/** Server-safe MUI theme (no "use client" directive). */
export const serverTheme = createTheme(themeOptions);
